import { createContext } from 'react'

const ScreenSizeContext = createContext<{ width: number; height: number }>(null)

export default ScreenSizeContext
